import { useState } from 'react';
import { AdcashGuruNAMMetrics } from '../../../../types/adcash.types';
import GuruPage from '../../../../components/adcash/guru/GuruPage';
import AdcashGuruDashboard from '../../../../components/adcash/guru/AdcashGuruDashboard';
import AdcashGuruNAMMericsTable from '../../../../components/adcash/guru/table/AdcashGuruNAMMericsTable';

const INITIAL: AdcashGuruNAMMetrics = {
  prevTotalRevenue: 0, prevTotalReq: 0, prevTotalImp: 0,
  totalRevenue: 0, totalReq: 0, totalImp: 0,
  dailyStats: [],
};

export default function GuruNAMApp() {
  const [exchangeRate, setExchangeRate] = useState<number>(1230);
  return (
    <GuruPage
      apiSlug="nam"
      initialMetrics={INITIAL}
      renderDashboard={(data) => <AdcashGuruDashboard dailyStats={data.dailyStats} exchangeRate={exchangeRate} />}
      renderTable={(data) => <AdcashGuruNAMMericsTable data={data} exchangeRate={exchangeRate} onExchangeRateChange={setExchangeRate} />}
    />
  );
}
